import { injectable } from 'inversify';
import * as yup from 'yup';
import { ALL_IMPORTMODE, Formats, ImportInput, ImportMode } from '../generated/types';
import { TranslationService } from '../services/translationService';
import { Emptyable } from '../util/emptyable';
import { CsvInputService } from './csvInput';
import { InputService } from './inputService';

@injectable()
export abstract class ImportInputService extends InputService {
    // TODO: add human-readable names too - integrate with/take from table headers (e.g. {@see `positionsImport.tsx:133–223`}) to avoid duplication
    // This will improve the automatching + sorting (e.g. {@see `columnMapping.tsx:24–57`} and {@see `mappableImportWizard.tsx:63–86`})
    static IMPORT_COLUMNS_DEFAULT = {
        /* This field can be required or not, depending on the selected import mode */
        Id: 'id'
    };

    static IMPORT_COLUMNS_REQUIRED = (mode: ImportMode) =>
        mode === ImportMode.Update ? [ImportInputService.IMPORT_COLUMNS_DEFAULT.Id] : [];

    constructor(
        protected csvInputService: CsvInputService,
        translationService: TranslationService
    ) {
        super(translationService);
    }

    default(formats: Emptyable<Formats>): { input: ImportInput } {
        return {
            input: {
                csv: this.csvInputService.csvDocumentInputDefault(formats),
                mode: ImportMode.CreateUpdate
            }
        };
    }

    schema() {
        return yup.object().shape({
            input: yup.object().shape({
                csv: this.csvInputService.schema(),
                mode: yup.string().oneOf(ALL_IMPORTMODE, this.t('le_mode_d_impor_75706'))
            })
        });
    }
}
